module.exports = __webpack_public_path__ + "img/logo_vm.7b7c752c.png";